import React from 'react';
import { Box, Chip } from '@mui/material';

const TagList = ({ items = [], color }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
    {items.map((item, i) => (
      <Chip 
        key={i} 
        label={item} 
        size="small" 
        sx={{ 
          bgcolor: color ? `${color}10` : 'primary.light',
          color: color || 'primary.main',
          border: 'none',
          fontSize: '0.7rem',
          height: '20px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
          '& .MuiChip-label': { px: 1 },
          mb: 0.5,
          transition: 'all 0.2s ease',
          '&:hover': {
            bgcolor: color ? `${color}20` : 'primary.light',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }
        }} 
      />
    ))}
  </Box>
);

export default TagList; 